import { Lifecycle } from "./Lifecycle";
import { executeScripts } from "./executeScripts";

type Args = {
    at: HTMLElement;
    code: string;
    /**
     * Only for debugging. Has no other impact on the code
     */
    debugLabel: string;
    lifecycle: Lifecycle;
};
export async function injectCustomCode({ at: contentRoot, code, debugLabel, lifecycle }: Args) {
    // Since we are potentially injecting the custom code outside
    // the `targetElement` (mainly in document.head), we need to
    // manually attach a cleanup here, since the page renderer
    // only cleans up the stuff inside the `targetElement`.

    const startComment = document.createComment(`Start of ${debugLabel} custom code`);
    contentRoot.appendChild(startComment);
    lifecycle.push(() => startComment.remove());

    const temporary = document.createElement("div");
    temporary.innerHTML = code;
    for (const child of Array.from(temporary.childNodes)) {
        contentRoot.appendChild(child);
        lifecycle.push(() => child.remove());
        if (child instanceof Element) {
            await executeScripts(child);
        }
    }

    const endComment = document.createComment(`End of ${debugLabel} custom code`);
    contentRoot.appendChild(endComment);
    lifecycle.push(() => endComment.remove());
}
